module.exports = __webpack_public_path__ + "static/img/h2-1.0b60999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h2-1.png
// module id = bCC2
// module chunks = 1